import { Button } from "@shared/ui";
import { ArrowRight, CheckCircle, FileSpreadsheet } from "lucide-react";
import styles from "./sheet.module.scss";

export interface SheetModeIntroProps {
  onContinue: () => void;
  title?: string;
  description?: string;
  bullets?: string[];
  buttonText?: string;
}

const DEFAULT_BULLETS = [
  "Preview commercials and deliverables before adding",
  "See failed creators with clear failure reasons",
];

export function SheetModeIntro({
  onContinue,
  title = "Import from spreadsheet",
  description = "Upload a sheet with creators, commercials, and deliverables. After processing you’ll get a summary of ready rows and any failed creators with reasons.",
  bullets = DEFAULT_BULLETS,
  buttonText = "Continue to upload",
}: SheetModeIntroProps) {
  return (
    <div className={styles.sheetIntro}>
      <div className={styles.sheetCard}>
        <div className={styles.sheetIcon}>
          <FileSpreadsheet size={22} />
        </div>
        <h4 className={styles.sheetTitle}>{title}</h4>
        <p className={styles.sheetDescription}>{description}</p>
        <Button
          type="primary"
          onClick={onContinue}
          className={styles.sheetContinue}
          icon={<ArrowRight size={16} />}
          iconPosition="end"
        >
          {buttonText}
        </Button>
      </div>
      {bullets && bullets.length > 0 && (
        <ul className={styles.sheetBullets}>
          {bullets.map((bullet, idx) => (
            <li key={idx}>
              <CheckCircle size={13} />
              {bullet}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
